// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-modal.open-chat-popover div.modal-wrapper {
  overflow: auto;
}
@media only screen and (min-width: 400px) {
  ion-modal.open-chat-popover div.modal-wrapper {
    left: 12.5vw;
  }
}
@media only screen and (min-height: 200px) {
  ion-modal.open-chat-popover div.modal-wrapper {
    left: 12.5vw;
  }
}
@media only screen and (max-width: 399px) {
  ion-modal.open-chat-popover div.modal-wrapper {
    left: calc(50% - 150px);
  }
}

ion-content {
  --background: transparent;
  --padding-bottom: 16px;
  --padding-end: 16px;
  --padding-start: 16px;
  --padding-top: 16px;
}

h4 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 20px;
}

.info {
  font-size: 14px;
}
.info.task-title {
  margin-top: 3px;
  margin-bottom: 6px;
  font-weight: bold;
}
.info.task-type-info {
  margin-top: 8px;
}
.info.task-date-info {
  margin-top: -12px;
  margin-bottom: 8px;
  text-transform: capitalize;
}

.bottom-buttons {
  padding: 16px;
  justify-content: flex-end;
}
.bottom-buttons ion-button {
  margin-left: 15px;
  min-width: 100px;
  height: 40px;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  --border-radius: 0 !important;
  --color: var(--ion-button-color-white);
  --background: var(--ion-color-chat-send-button);
}
.bottom-buttons ion-button:hover {
  background-color: rgba(158, 158, 158, 0.1);
}

.calendar {
  width: 100%;
  max-width: 390px;
}`, "",{"version":3,"sources":["webpack://./src/components/mark-task-done/mark-task-done.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EAHF;IAII,YAAA;EAEF;AACF;AAAE;EAPF;IAQI,YAAA;EAGF;AACF;AADE;EAXF;IAYI,uBAAA;EAIF;AACF;;AADA;EACE,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAIF;;AADA;EACE,eAAA;AAIF;AAFE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AAIJ;AADE;EACE,eAAA;AAGJ;AAAE;EACE,iBAAA;EACA,kBAAA;EACA,0BAAA;AAEJ;;AAEA;EACE,aAAA;EACA,yBAAA;AACF;AACE;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EAEA,6BAAA;EACA,sCAAA;EACA,+CAAA;AAAJ;AAEI;EACE,0CAAA;AAAN;;AAKA;EACE,WAAA;EACA,gBAAA;AAFF","sourcesContent":["ion-modal.open-chat-popover div.modal-wrapper {\n  overflow: auto;\n\n  @media only screen and (min-width: 400px) {\n    left: calc(50vw - (75vw / 2));\n  }\n\n  @media only screen and (min-height: 200px) {\n    left: calc(50vw - (75vw / 2));\n  }\n\n  @media only screen and (max-width: 399px) {\n    left: calc(50% - (300px / 2));\n  }\n}\n\nion-content {\n  --background: transparent;\n  --padding-bottom: 16px;\n  --padding-end: 16px;\n  --padding-start: 16px;\n  --padding-top: 16px;\n}\n\nh4 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-size: 20px;\n}\n\n.info {\n  font-size: 14px;\n\n  &.task-title {\n    margin-top: 3px;\n    margin-bottom: 6px;\n    font-weight: bold;\n  }\n\n  &.task-type-info {\n    margin-top: 8px;\n  }\n\n  &.task-date-info {\n    margin-top: -12px;\n    margin-bottom: 8px;\n    text-transform: capitalize;\n  }\n}\n\n.bottom-buttons {\n  padding: 16px;\n  justify-content: flex-end;\n\n  ion-button {\n    margin-left: 15px;\n    min-width: 100px;\n    height: 40px;\n    font-weight: 600;\n    font-size: 1rem;\n    text-transform: uppercase;\n\n    --border-radius: 0 !important;\n    --color: var(--ion-button-color-white);\n    --background: var(--ion-color-chat-send-button);\n\n    &:hover {\n      background-color: rgba(158, 158, 158, 0.1);\n    }\n  }\n}\n\n.calendar {\n  width: 100%;\n  max-width: 390px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
